import { render, staticRenderFns } from "./b2b.vue?vue&type=template&id=5bde0cd0&lang=pug&"
import script from "./b2b.vue?vue&type=script&lang=js&"
export * from "./b2b.vue?vue&type=script&lang=js&"
import style0 from "./b2b.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports